/**
 * Links to a video guide: ?video=<videoId> ("Copy link" under each video), and
 * for a film (a long guide in chapters) optionally &chapter=<chapterKey>.
 * The app reads them once login state is ready and opens Support → Guides
 * scrolled to the video (a film starts at the chapter). A signed-out visitor
 * sees the login form first; the address keeps the link. `?guide=<anything>`
 * (older links) just opens Guides.
 */
const KEYS = ['guide', 'video', 'chapter'];
const ID_RE = /^[a-z0-9-]{1,80}$/;

let pending = null;

/**
 * Read and clear the link params from the address bar (once): `{ open, videoId }`
 * (plus `chapter` when the link names one) or `{}`.
 */
export function consumeGuideDeepLink() {
  if (pending !== null) return pending;
  if (typeof window === 'undefined') return (pending = {});
  const params = new URLSearchParams(window.location.search);
  const read = (key) => {
    const value = String(params.get(key) || '').trim();
    return ID_RE.test(value) ? value : null;
  };
  const videoId = read('video');
  const chapter = videoId ? read('chapter') : null;
  const out = videoId || read('guide') ? { open: true, videoId } : {};
  if (chapter) out.chapter = chapter;
  if (KEYS.some((k) => params.has(k))) {
    KEYS.forEach((k) => params.delete(k));
    const rest = params.toString();
    window.history.replaceState({}, document.title, `${window.location.pathname}${rest ? `?${rest}` : ''}${window.location.hash || ''}`);
  }
  pending = out;
  return pending;
}

/** The link "Copy link" puts on the clipboard; `chapter` starts a film there. */
export function buildGuideVideoLink(origin, videoId, chapter = null) {
  const base = String(origin || '').replace(/\/+$/, '');
  const params = { video: videoId };
  if (chapter) params.chapter = chapter;
  return `${base}/?${new URLSearchParams(params).toString()}`;
}
